<template>
  <div class="container-c-time">
    <van-popup v-model="showPop" position="bottom" :style="{ height: '35%' }" @close="closePop">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        :cancel-button-text="$t('lang.cfm.cancelBtn')"
        :confirm-button-text="$t('lang.confirm')"
        title=""
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="confirm(currentDate)"
        @cancel="cancel(currentDate)" />
    </van-popup>
  </div>
</template>

<script>
// 这个是 （ 年 月 ） 格式
export default {
  components: {},
  props: {
    showPop: {
      default: false
    }
  },
  data() {
    return {
      minDate: new Date(2023, 0, 1),
      maxDate: new Date(2099, 11, 1),
      currentDate: new Date(),
      chooseTime: ''
    }
  },
  created() {},
  mounted() {},
  methods: {
    confirm(time) {
      this.chooseTime = time
      this.$parent.closePop()
      this.$emit('handleCurrentDate', this.chooseTime)
    },
    cancel() {
      this.$parent.closePop()
    },
    closePop() {
      this.$parent.closePop()
    }
  },
  watch: {},
  computed: {}
}
</script>
<style lang="scss" scoped>
.container-c-time {
}
::v-deep .van-icon-arrow-down:before {
  // color: #c0c0c0;
  color: pink !important;
}
</style>
